module.exports = __webpack_public_path__ + "img/fangxun.ad7439bc.png";